
const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000007';
const OVERLAP = 120; // centiunits (1.2in)
const ENDCAP_WIDTH = 300; // 3in, matches choice 500002/500003 metadata
const RAIL_WIDTH = 1650; // 16.5in, matches choice 500001 metadata
const HEIGHT = 480; // 4.8in, shared by all three parts

const endCapLeftColumn = 0;
const wallRailColumn = endCapLeftColumn + ENDCAP_WIDTH - OVERLAP;
const endCapRightColumn = wallRailColumn + RAIL_WIDTH - OVERLAP;

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock Ryobi Wall Rail + End Caps Bundle',
  Version: 1,
  ProductTypeId: 97,
  Sku: 315503116,
  Surface: null,
  Matrix: { Rows: 1, Columns: 10, Segments: null },
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'ryobi-endcap-left-1',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail End Cap - Left',
      ChoiceId: 500002,
      Origin: {
        Row: 0, Column: endCapLeftColumn, Height: HEIGHT, Width: ENDCAP_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'ryobi-wall-rail-1',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail',
      ChoiceId: 500001,
      Origin: {
        Row: 0, Column: wallRailColumn, Height: HEIGHT, Width: RAIL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'ryobi-endcap-right-1',
      Type: 'Accessory',
      Sku: null,
      Name: 'RYOBI Wall Rail End Cap - Right',
      ChoiceId: 500003,
      Origin: {
        Row: 0, Column: endCapRightColumn, Height: HEIGHT, Width: ENDCAP_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const ryobiWallRailWithEndcapsBundleMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default ryobiWallRailWithEndcapsBundleMock;
